// @flow
import {
    Box, Button, CheckBox,
} from 'grommet';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { BaseSelect } from 'speed-js-react-web/src/components/fields';
import { FieldWrapper } from 'speed-js-react-web';


type Props = {
    columns: Array<{
        Header: React.Node,
        accessor?: string,
        [string]: any,
    }>,
    initialExcludedColumns: Array<number>,
    container: React.ComponentType<{ tableId: string }>,
    onSubmit: (excludedColumns: Array<number>, rc: number) => void,
    tableId: string,
    numberOfRows: number,
}

type State = {
    excludedColumns: Array<number>,
    rowCount: number,
}

const twentyFive = 25;
const fifty = 50;
const oneHundred = 100;
const twoHundredFifty = 250;
const fiveHundred = 500;

const numberOfRowsPerPage = {
    [twentyFive]: 25,
    [fifty]: 50,
    [oneHundred]: 100,
    [twoHundredFifty]: 250,
    [fiveHundred]: 500,
};

class ColumnSettingsForm extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            excludedColumns: props.initialExcludedColumns,
            rowCount: props.numberOfRows,
        };
    }


    componentDidUpdate(prevProps: Props) {
        const { initialExcludedColumns } = this.props;
        if (prevProps.initialExcludedColumns !== initialExcludedColumns) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ excludedColumns: initialExcludedColumns });
        }
    }

    handleSubmit = () => {
        const { onSubmit } = this.props;
        const { excludedColumns, rowCount } = this.state;
        onSubmit(excludedColumns, rowCount);
    };

    handleChange = (columnidx: number) => {
        this.setState((prevState) => {
            if (prevState.excludedColumns.includes(columnidx)) {
                return {
                    ...prevState,
                    excludedColumns:
                        prevState.excludedColumns.filter((idx) => idx !== columnidx),
                };
            }

            return {
                ...prevState,
                excludedColumns: prevState.excludedColumns.concat([columnidx]),
            };
        });
    };

    handleRowCountChange = (rc: number) => {
        this.setState({ rowCount: rc });
    }

    render() {
        const { columns, container: Container, tableId } = this.props;
        const { excludedColumns, rowCount } = this.state;

        return (
            <Container tableId={tableId}>
                {(handleClose, Actions, formRef) => (
                    <Box
                        ref={formRef}
                        as="form"
                        onSubmit={(e) => {
                            e.preventDefault();
                            this.handleSubmit();
                            handleClose(excludedColumns);
                        }}
                        onReset={() => {
                            this.setState({
                                excludedColumns: this.props.initialExcludedColumns,
                            });
                            handleClose();
                        }}
                        flex
                    >
                        <Box gap="small" justify="start" alignContent="start" overflow="auto" pad="small" flex>
                            <FieldWrapper
                                key="row-count"
                                required
                                label={(
                                    <FormattedMessage id="row-count" defaultMessage="Row count" />
                                )}
                            >
                                <BaseSelect
                                    allowEmptyChoice={false}
                                    choices={numberOfRowsPerPage}
                                    onChange={this.handleRowCountChange}
                                    value={rowCount}
                                />
                            </FieldWrapper>
                            <FieldWrapper
                                key="column-choice"
                                label={(
                                    <FormattedMessage id="column-choice" defaultMessage="Column choice" />
                                )}
                            />
                            {columns.map((column, index) => (
                                <CheckBox
                                    key={index.toString()}
                                    checked={!excludedColumns.includes(index)}
                                    label={column.actions ? (
                                        <FormattedMessage id="projmanag-task-actions" defaultMessage="Actions" />
                                    ) : column.Header}
                                    onChange={() => this.handleChange(index)}
                                />
                            ))}
                        </Box>
                        {Actions ? <Actions disabled={!rowCount} /> : (
                            <Box
                                direction="row"
                                margin={{ vertical: 'small' }}
                                gap="small"
                                pad="small"
                            >
                                <Box flex height="36px">
                                    <Button
                                        label={<FormattedMessage id="save-btn" defaultMessage="Save" />}
                                        type="submit"
                                        disabled={!rowCount}
                                        fill
                                    />
                                </Box>
                            </Box>
                        )}
                    </Box>
                )}
            </Container>
        );
    }
}

export default ColumnSettingsForm;
